// File: frontend/src/pages/KnowledgeGraph/components/ExampleQueries.tsx
import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  Stack,
} from '@mui/material';
import { EXAMPLE_QUERIES } from '../types';
import { cyber } from '../../../theme';

interface ExampleQueriesProps {
  onSelect: (term: string) => void;
}

const ExampleQueries: React.FC<ExampleQueriesProps> = ({ onSelect }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
        Explore Examples
      </Typography>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          overflowX: 'auto',
          pb: 1,
          '&::-webkit-scrollbar': { height: 4 },
          '&::-webkit-scrollbar-thumb': { bgcolor: 'divider', borderRadius: 2 },
        }}
      >
        {EXAMPLE_QUERIES.map((example) => (
          <Card
            key={example.term}
            sx={{ minWidth: 180, maxWidth: 220, flexShrink: 0 }}
          >
            <CardActionArea onClick={() => onSelect(example.term)}>
              <CardContent sx={{ py: 2, px: 2 }}>
                <Typography variant="subtitle2" fontWeight="bold" sx={{ fontFamily: cyber.fontMono }}>
                  {example.term}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {example.subtitle}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Stack>
    </Box>
  );
};

export default ExampleQueries;
